import { IsString, IsNumber, IsIn, Matches, IsOptional } from 'class-validator';
import { GrantInterface, GrantAction } from './grant.interface';
import { AbstractModel } from '../models/abstract.model';


export class GrantModel extends AbstractModel implements GrantInterface {

    /**
     * roleId can't hold a user Id directly.
     * If a user need a special grant, the user have insert into a new role.
     */
    @IsNumber()
    public _roleId: number = -1;

    /**
     * - c = create
     * - r = read
     * - u = update
     * - d = delete
     * - m = manage, update grants
     *
     * Examples:
     * - cru = create, read, update
     * - r = read
     */
    @IsString()
    @Matches(/^[crudm]{1,5}$/gm, {
        message: 'action must only have some of the characters: crudm'
    })
    actions: string = 'crudm';

    /**
     * If entityId is undefined this grant is for the whole entityList
     */
    @IsNumber()
    @IsOptional()
    entityId?: number;

    @IsString()
    entityName: string = '';

    public can(action: GrantAction): boolean {
        const char = action.charAt(0);
        return this.actions.includes(char);
    }

    public enableAction(action: GrantAction) {
        if (!this.can(action)) {
            this.actions += action;
        }
    }

    public disableAction(action: GrantAction) {
        this.actions.replace(action, '');
    }

    constructor(roleId: number, action: string, entityName: string, entityId?: number) {
        super();
        this._roleId = roleId;
        this.actions = action;
        this.entityName = entityName;
        this.entityId = entityId;
    }

}
